/**
 * ag游戏大厅
 */
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import RichHeader from './RichHeader.jsx';
import SideBar from '../../components/affix/SideBar.jsx';
import Loader from '../../components/icon/Loader.jsx';
import Page from '../../components/tools/gamePage.jsx'
import GameItem from '../../components/panel/gameItemNoBtn.jsx'
import TransferMoney from '../../components/modal/TransferMoney.jsx'
import ResetPasswordAlert from '../../components/modal/ResetPasswordAlert.jsx'
import Footer from '../../components/footers/Original_Main.jsx';
import FullScreenBanner  from '../../components/banner/FullScreenBanner.jsx';

class AGGameHall extends React.Component {
  	constructor(props) {
	    super(props);
      this.changeCurrentPage = this.changeCurrentPage.bind(this);
      this.initSelectd = this.initSelectd.bind(this);
      this.changeCurrentCategory = this.changeCurrentCategory.bind(this);
      this.handleChangePassword = this.handleChangePassword.bind(this);
      this.resetTheMenuLeft = this.resetTheMenuLeft.bind(this);
      this.handleCreateNewUser = this.handleCreateNewUser.bind(this);
      this.hideMenu = this.hideMenu.bind(this);
      this.openMenu = this.openMenu.bind(this);
	    this.state = {
        currentPage: 1,
        currentCategory: null,
        hiddenSiderbar: false
	    }
  	}
    
  	componentDidMount() {
	     // 获取AG余额
      this.props.$$USER.getPlatformBalance('ag');

      // 获取游戏分类
      this.props.$$GAME.getGameCategories(3);

      // 获取AG热门游戏
      this.props.$$GAME.getHotGame(3);

      // 获取AG广告banner
      this.props.$$GAME.getAds4Banner(5, 3);

      // 获取平台用户信息
      this.props.$$USER.getPlatformProfile('ag');

      const categories = this.props.__GAME.toJS().categories;
      if (categories.length > 0) {
        this.initSelectd(categories, this.props.match.params.type);
      }

      $.scroll2Top();

      // 第一次执行
      this.resetTheMenuLeft();
      // 每次resize执行
      window.addEventListener('resize', this.resetTheMenuLeft);

  	}

    componentWillReceiveProps(nextProps) {
      const categories = this.props.__GAME.toJS().categories;
      const nextCategories = nextProps.__GAME.toJS().categories;
      const hotTab = {id:"49", name:"热门游戏", platform_id:"3"} 
      if(nextProps.__GAME.toJS().ag.hot.length>0){
        this.allCategories = _.concat(hotTab,nextCategories)
        if(this.state.currentCategory == 49){
          this.allContents = nextProps.__GAME.toJS().ag.hot[0].list
        }else{
          if(nextProps.__GAME.toJS().ag.contents!=null){
            this.allContents = nextProps.__GAME.toJS().ag.contents.list
          }
        }
      }
      if (categories.length == 0 && nextCategories.length > 0) {
        this.initSelectd(nextCategories, nextProps.match.params.type);
        return
      }
      // 类型变更
      if (this.props.match.params.type != nextProps.match.params.type) {
        this.initSelectd(nextCategories, nextProps.match.params.type);
        return;
      }
            
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.resetTheMenuLeft, false);
    }

    // 设置默认选中
    initSelectd(categories, type){
      let currentCategory = null
      switch(type){
        case 'casino': currentCategory = '47'; break;
        case 'slot': currentCategory = '46'; break;
        default: currentCategory = _.filter(categories, {platform_id: '3'})[0].id;
      }
      // 如果相同则跳过
      if (this.state.currentCategory == currentCategory) {
          return;
      }
      // 设置当前分类
      this.setState({
        currentCategory: currentCategory
      })
      this.changeCurrentPage(1, currentCategory)
    }

    // 翻页
    changeCurrentPage(pageNo, currentCategory){
      this.setState({
        currentPage:pageNo
      }) 
      this.props.$$GAME.getCurrentGameList(3, currentCategory || this.state.currentCategory, pageNo, 10);
    }

    // 切换分类
    changeCurrentCategory(categoryId){
      // 如果相同则跳过
      if (this.state.currentCategory == categoryId) {
          return;
      }
      // 设置当前分类
      this.setState({
        currentCategory: categoryId
      })
      this.changeCurrentPage(1, categoryId)
    }

   	//打开转账弹窗
    openTransfer(platfrom){
    	this.props.$$BASE.openOverlay()
      this.props.$$BASE.openTransferModal(platfrom)
    }

    //关闭转账弹窗
    hideTransfer(){
    	this.setState({
    		transferModal: false
    	})
    	this.props.$$BASE.closeOverlay()
    }

    //打开重置密码弹窗
    openRestpassword(){
    	this.setState({
    		resetPasswordModal: true
    	})
    	this.props.$$BASE.openOverlay()
    }

    //关闭重置密码弹窗
    hidePassword(){
    	this.setState({
    		resetPasswordModal: false
    	})
    	this.props.$$BASE.closeOverlay()
    }

    // 重置密码
    handleChangePassword(newPassword){
      if (!/^[0-9a-zA-Z]{6,8}$/.test(newPassword)) {
        alert('密码不符合要求（6-8位数字和字母组合），请重新输入。')
        return;
      }
      this.hidePassword();
      this.props.$$GAME.resetPlatformPassword(newPassword, 'ag');

    }
    // 重新计算侧栏菜单的left值

    resetTheMenuLeft(forceShow) {
      let baseWidth = 1080;
      let leftWidth = 230;
      let offsetLeft = (document.documentElement.clientWidth - baseWidth) / 2;
      if (offsetLeft > 230) {
        ReactDOM.findDOMNode(this.refs.widBox).style.left = (offsetLeft - leftWidth) + "px";
      } else {
        ReactDOM.findDOMNode(this.refs.widBox).style.left = "12px";
        if (forceShow) return;
        this.hideMenu()
      }
    }

    // 隐藏到侧边
    hideMenu() {
      this.setState({
        'hiddenSiderbar': true
      })
    }

    // 打开菜单
    openMenu() {
      this.setState({
        'hiddenSiderbar': false
      })
      this.resetTheMenuLeft(true);
    }

    // 创建新用户
    handleCreateNewUser(){
      let username = ReactDOM.findDOMNode( this.refs.username ).value;
      if (!/^[0-9a-z]{4,11}$/.test(username)) {
        alert('请输入4-11位数字或小写字母');
        return;
      }
      this.props.$$USER.createPlatformAccount('ag', username)
    }
  	render() {
	    let __base = this.props.__BASE.toJS();
	    let __game = this.props.__GAME.toJS();
	    let __user = this.props.__USER.toJS();
      let {tabActive, onePageDate, current,currentCategory} = this.state
      if(currentCategory == 49){
        this.allContents = __game.ag.hot ? __game.ag.hot[0].list :[]
      }else{
        if(__game.ag.contents!=null){
          this.allContents = __game.ag.contents ? __game.ag.contents.list :[];
        }
      }
      return (
        <div>
          <div className='game-framework'>
            <RichHeader />
            <div className='banner-framework'>
              <FullScreenBanner list={__game.ag.ads} />
            </div>
            <SideBar hasClass ="indexSideBar" />
            {/*转账*/}
            <div className="pt-left-bar"
                className={this.state.hiddenSiderbar ? 'pt-left-bar hiding' : 'pt-left-bar'} ref="widBox"
            >
                <h3 className="pt-left-title" title="您的AG余额" onClick={this.hideMenu}>
                  <b></b>
                  我的账户
                </h3>
                  <div className="pt-left-money">
                    <p>您当前的AG余额(元)</p>
                    <span className="number">{__user.balance.ag}</span>
                  </div>
                  <div className="my-pt-submit my-ag-submit">
                    <a href="javascript:;" className="pt-recharge" onClick={this.openTransfer.bind(this,'AG')}>游戏转账</a>
                  </div>
                  <p className="money-bg"></p>
            </div>
            <div className={this.state.hiddenSiderbar ? 'open-my-pt strongshow' : 'open-my-pt'} 
                 onClick={this.openMenu}>
                 <b></b>
                我的账户
            </div>

         		<div id="pt_background">
         		  <div className="pt-body">    
  	            <div className="pt-body-content">
                  <h3>AG娱乐平台</h3>
  	              <div className="pt-menu-ul">
  	                <dl className="pt-menu-li">
  	                  <dt>游戏类型</dt>
  	                  {
                        __game.categories.length == 0 ? <Loader /> : 
                          _.filter(this.allCategories, {platform_id: '3'}).map((item, index) => 
                            <dd key={index} className={item.id == this.state.currentCategory ? 'active' : ''} onClick={this.changeCurrentCategory.bind(this, item.id)} >
                              <a className='pointer'>{item.name}</a>
                            </dd>
                          )
                      }
  	                </dl>
  	              </div>
  	              <div className="pt-list">
  	                <ul className="pt-game-card">
  	                	{
                        __game.ag.hot == null|| __game.ag.contents == null? <Loader /> :
                        this.allContents?
                        this.allContents.map((item,index)=>
                          <GameItem platform='ag' key={index} val={item} />
                        ):null
                      }
  	                </ul>
  	                <div className="cf"></div>
                    {
                        this.state.currentCategory== 49|| __game.ag.contents == null? null :
                      <Page className="pt-paging" allData={__game.ag.contents.count || 0} onePageDate='10' current={this.state.currentPage} changeCurrentPage={this.changeCurrentPage}/>               
                    }
  	              </div>
  	            </div>
  	          </div>
         		</div>
            <div className={__user.platform_profile.ag.available ? 'hide' : 'block'}>
              <div className="change_cont">
                <div className="chargebg">
                  <a href="javascript:history.back();" className="close-icon" title="取消">×</a>
                  <h2 id="changeTitle">请设置您的AG用户名</h2>
                  <div className="charge_input">
                    <p>用户名：<input type="text" placeholder="请输入您想设置的用户名" ref='username' /></p>
                    <div className="tips">由4-11位数字或小写字母组成（不允许特殊字符）</div>
                  </div>
                  <div className="submit-box">
                    <input type="button" value="确定" className="change_btn" onClick={this.handleCreateNewUser} />
                  </div>
                </div>
              </div>
              <div className='overlay-mask'></div>
            </div>
            <div id="pt_footer">
  	          <Footer />
            </div>
          </div>
          <ResetPasswordAlert platform='BBIN' submit={this.handleChangePassword} display={this.state.resetPasswordModal} close={this.hidePassword.bind(this)} userName={__user.platform_profile['pt'].userInfo ? __user.platform_profile['pt'].userInfo.username : ''}/>
        </div>
      ); 
    }
} 

reactMixin(AGGameHall.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __GAME: state.game,
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$GAME: bindActionCreators(gameAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AGGameHall)